import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { School } from '../../data/types/school';

interface SchoolState {
  schoolList: School[];
  selectedSchool: School | null;
  error: string | null;
}

const initialState: SchoolState = {
  schoolList: [],
  selectedSchool: null,
  error: null,
};

const schoolSlice = createSlice({
  name: 'school',
  initialState,
  reducers: {
    setSchoolList: (state, action: PayloadAction<School[]>) => {
      state.schoolList = action.payload;
    },
    setSelectedSchool: (state, action: PayloadAction<School>) => {
      state.selectedSchool = action.payload;
    },
    createSchoolSuccess: (state, action: PayloadAction<School>) => {
      state.schoolList.push(action.payload)
      state.error = null
    },
    createSchoolFailure: (state, action: PayloadAction<string>)=>{
      state.error = action.payload;
    },
    updateSchoolSuccess: (state, action: PayloadAction<School>) => {
      const index = state.schoolList.findIndex(school => school.id === action.payload.id);
      if (index !== -1) {
        state.schoolList[index] = action.payload;
      }
      state.error = null;
    },
    updateSchoolFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    deleteSchoolSuccess: (state, action: PayloadAction<number>) => {
      state.schoolList = state.schoolList.filter(school => school.id !== action.payload)
      state.error = null;
    },
    deleteSchoolFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});

export const { setSchoolList, setSelectedSchool, createSchoolSuccess, createSchoolFailure, updateSchoolSuccess, updateSchoolFailure, deleteSchoolSuccess, deleteSchoolFailure } = schoolSlice.actions;
export default schoolSlice.reducer;